import { apiSlice } from "../apiSlice";

export interface SalesPayoutStatisticsResponse {
  totalEarnings: number;
  totalOrderCount: number;
  totalPayoutsToCarts: number;
  totalPayoutsToRestaurants: number;
  totalSales: number;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface Owner {
  userId: string;
  ownerId: string;
}

export interface cartOwner {
  id: string;
  userId: string;
};

export interface Restaurant {
  id: string;
  address: string;
  displayName: string;
  categoryTags: string[];
  averageDeliveryTime: string | null;
  imageUrl: string;
  location: Location;
  rating: number;
  hasOffers: boolean;
  isMember: boolean;
  owner: Owner;
  openingTime: string;
  closingTime: string;
  type: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  status: string;
  score: number;
}

export interface TrendingCart {
  id: string;
  createdAt: {
    _seconds: number;
    _nanoseconds: number;
  };
  updatedAt?: {
    _seconds: number;
    _nanoseconds: number;
  };
  imageUrl: string;
  location: Location;
  merchantId?: string;
  displayName: string;
  isFixedLocation: boolean;
  restaurantIds?: string[];
  isOnline: boolean;
  owner: cartOwner;
  status: string;
  score: number;
  reasonForBeingOffline?: string | null;
}

export interface OrderRefunding {
  refundRequestId: string;
  status: string;
}

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;

export const dashboardService = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSalesPayoutStatistics: builder.query<SalesPayoutStatisticsResponse, { startTime: string, endTime: string }>({
      query: ({ startTime, endTime }) => {
        return {
          url: `https://superadminhttps-get-sales-payout-statistics-by-da-${API_BASE_DOMAIN}-uc.a.run.app/?startTime=${startTime}&endTime=${endTime}`,
          method: "GET",
          responseHandler: (response) => response.json(),
        };
      },
    }),

    getTrendingRestaurants: builder.query<Restaurant[], void>({
      query: () => ({
        url: `https://superadminhttps-gettrendingrestaurantsfromscore-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "GET",
        responseHandler: (response) => response.json(),
      }),
    }),

    getTrendingCarts: builder.query<TrendingCart[], void>({
      query: () => ({
        url: `https://superadminhttps-gettrendingcartsfromscore-${API_BASE_DOMAIN}-uc.a.run.app/`,
        method: "GET",
        responseHandler: (response) => response.json(),
      }),
    }),
  }),
});

export const {
  useGetSalesPayoutStatisticsQuery,
  useLazyGetSalesPayoutStatisticsQuery,
  useGetTrendingRestaurantsQuery,
  useLazyGetTrendingRestaurantsQuery,
  useGetTrendingCartsQuery,
  useLazyGetTrendingCartsQuery,
} = dashboardService;
